<template>
  <!-- <dv-full-screen-container> -->
  <el-container class="index_container">
    <indexHeader class="index_header" @fatherMethod="didGetSelect" />
    <el-main class="index_mainWrap">
      <div class="main_contentFlex">
        <!-- 左边模块 -->
        <div class="col_l">
          <waterAnalyze ref='left1' />
          <waterPlan ref='left2' />
          <waterSaving ref='left3' />
        </div>
        <!-- 中 -->
        <div class="col_c">
          <waterSupplyMonitor ref='center1' />
          <waterBalance ref='center2'/>
        </div>
        <!-- 右边模块 -->
        <div class="col_r">
          <deviceManager ref='right1' />
          <waterHistory ref='right2'/>
          <waterLeak ref='right3'/>
        </div>    
      </div>
    </el-main>
  </el-container>
  <!-- </dv-full-screen-container> -->
</template>

<script>
import borderBox from '../../components/borderBox'
import indexHeader from './components/indexHeader.vue'
import waterAnalyze from './components/waterAnalyze.vue'
import waterPlan from './components/waterPlan.vue'
import waterSaving from './components/waterSaving.vue'
import waterSupplyMonitor from './components/waterSupplyMonitor.vue'
import waterBalance from './components/waterBalance.vue'
import deviceManager from './components/deviceManager.vue'
import waterHistory  from './components/waterHistory.vue'
import waterLeak  from './components/waterLeak.vue'

export default {
  components: {
    borderBox,
    indexHeader,
    waterAnalyze,
    waterPlan,
    waterSaving,
    waterSupplyMonitor,
    waterBalance,
    deviceManager,
    waterHistory,
    waterLeak,
  },
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    didGetSelect(){
      console.log(23333);
      this.$refs.left1.getData();
      this.$refs.left2.getData();
      this.$refs.left3.getData();
      this.$refs.center1.getData();
      this.$refs.right1.getData();
      this.$refs.right3.getData();
    }
  }
}
</script>

<style lang="less" scoped>
  .index_container {
    width: 100%;
    height: 100%;
    background-color: #133049;
    position: relative;    
    .index_header {
      width: 100%;
      height: 60px;
    }
    .index_mainWrap {
      width: calc(100% - 60px);
      height: calc(100% - 60px);
      margin: 0 auto;
      position: absolute;
      top: 40px;
      bottom: 10px;
      left: 10px;
      right: 10px;
      background: url("../../assets/image/index/+wrapper-bg.png");
      background-size: 100% 100%;
      box-sizing: border-box;    
      .main_contentFlex {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        padding: 12px;
        height: 100%;
      }    
    }
  }

</style>